import { ChevronLeft, ChevronRight } from 'lucide-react'
import { useId } from 'react'
import { Select } from '@/components/ui/Select'
import type { TeamPersonWeek } from '@/lib/types'

/**
 * Bladeren door teamleden zonder terug te hoeven naar de lijst. Dezelfde
 * pil-vorm als WeekNav, zodat de balk een stepper voor de week en een stepper
 * voor de persoon naast elkaar heeft.
 */
export function PersonSwitcher({
  persons,
  personId,
  personName,
  onChange,
}: {
  persons: TeamPersonWeek[]
  personId: string
  personName: string
  onChange: (personId: string) => void
}) {
  const labelId = useId()
  const index = persons.findIndex((person) => person.personId === personId)
  const known = persons.some((person) => person.personId === personId)
  const options = [
    ...(known ? [] : [{ value: personId, label: personName }]),
    ...persons.map((person) => ({ value: person.personId, label: person.displayName })),
  ]

  return (
    <>
      <span id={labelId} className="sr-only">Persoon</span>
      <div className="inline-flex items-center gap-1 rounded-lg border border-hairline bg-surface p-0.5">
        <button
          type="button"
          onClick={() => index > 0 && onChange(persons[index - 1].personId)}
          disabled={index <= 0}
          className="btn-ghost h-8 w-8 p-0"
          aria-label="Vorige persoon"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        <Select
          value={personId}
          onValueChange={onChange}
          options={options}
          ariaLabelledby={labelId}
          className="h-8 min-w-44 border-0"
        />
        <button
          type="button"
          onClick={() => index >= 0 && index < persons.length - 1 && onChange(persons[index + 1].personId)}
          disabled={index < 0 || index >= persons.length - 1}
          className="btn-ghost h-8 w-8 p-0"
          aria-label="Volgende persoon"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </>
  )
}
